module.exports = __webpack_public_path__ + "static/media/PropertyRealEstate.6006751b.jpg";